import * as React from 'react';
import { FormField, Input } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { TextAndStyleConsentButtonMaxLength } from '@src/constants/constants';

const MAX_LEN = TextAndStyleConsentButtonMaxLength;

interface Props extends InjectedTranslateProps {
  value: string;
  onChange: (value: string) => void;
}

const ConsentButtonEditorBase = ({ t, value, onChange }: Props) => (
  <FormField
    label={t('text-and-display.consent-button.title')}
    infoContent={t('text-and-display.consent-button.tooltip')}
    charCount={MAX_LEN - value.length}
  >
    <Input
      dataHook={DataHooks.TextAndDisplayConsent}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      maxLength={MAX_LEN}
    />
  </FormField>
);

export const ConsentButtonEditor = translate()(ConsentButtonEditorBase);
